/**
 * Parse the DOM for the given selector. If the value matches an item in the giv                                                                en index, create instances of it.
 *
 * @module Modules/DomParser
 */

import * as _ from 'underscore';

/**
 * DomParser
 * @constructor
 */
let DomParser = function (index, selector) {
    this.selector = selector;
    this.index = index;

    return this;
};

/**
 * parse
 * @description Parse trough the DOM.
 * @memberof module:Modules/DomParser
 * @returns {DomParser}
 */
DomParser.prototype.parse = function () {
    // Create the module instances.
    _.each($('[data-' + this.selector + ']'), function (el) {

        let val = el.dataset[this.selector],//.data('module'),
            Module = this.index[val],
            instance;

        // Check if the attr's value is in the index.
        if (!Module) {
            console.warn('Module "' + val + '" is not listed in the index.');
            return;
        }

        // Create the instance of the Module.
        instance = new Module(el, el.dataset);
    }.bind(this));

    return this;
};

export default DomParser;
